export default __webpack_public_path__ + "static/media/icon-report.97558e46.svg";